import { CellAlignment } from 'hooks/useTable/types'
import { isFinite } from 'lodash'
import { formatPercent } from 'ui/helpers'

const numberFormat = Intl.NumberFormat()

export const columnDefaults = {
  cellAlignment: CellAlignment.Left,
  disableSort: false,
  filterable: false,
  filterConfig: undefined,
  primary: false,
  quickFilterable: false,
  quickFilterTooltipContent: null,
  searchable: false,
  valueFormatter: value => value,
  wrapText: false,
}

export const numericColumnDefaults = {
  ...columnDefaults,
  cellAlignment: CellAlignment.Right,
  valueFormatter: value => {
    const asNumber = Number(value)
    if (!isFinite(asNumber)) return value

    return numberFormat.format(asNumber)
  },
}

export const percentageColumnDefaults = {
  ...numericColumnDefaults,
  valueFormatter: formatPercent,
}
